import { LikutBarcodeDefinition } from '@interfaces/likut';
import { SerialNumSQL } from '@interfaces/service-call';
import { AllClients, AllProducts, DocTypeDefinitions } from '@interfaces/SQL-morning-responses';
import { Users } from '@interfaces/users';

export type DisplayFnOptions =
	| {
			mode: 'clients';
			value: AllClients;
	  }
	| {
			mode: 'agents';
			value: Users;
	  }
	| {
			mode: 'doctypes';
			value: DocTypeDefinitions;
	  }
	| {
			mode: 'products';
			value: AllProducts;
	  }
	| {
			mode: 'barcodeDefinitions';
			value: LikutBarcodeDefinition;
	  }
	| {
			mode: 'serials';
			value: SerialNumSQL;
	  };

export function displayFn(options: DisplayFnOptions): string {
	const { mode, value } = options;
	switch (mode) {
		case 'clients':
			return value?.Client_Name && value?.ClientId ? `${value.ClientId} - ${value.Client_Name}` : '';

		case 'agents':
			return value?.UserId && value?.UserName ? `${value.UserId} - ${value.UserName}` : '';

		case 'doctypes':
			return value?.DocType && value?.DocTypeName ? `${value.DocType} - ${value.DocTypeName}` : '';

		case 'serials':
			return value?.ProductId && value?.SerNum ? `${value.ProductId} / ${value.SerNum}` : '';
		case 'products':
			return value?.ProductId && value?.Product_Name ? `${value.ProductId} - ${value.Product_Name}` : '';
		case 'barcodeDefinitions':
			return value?.Id && value?.BarcodeName ? `${value.Id} - ${value.BarcodeName}` : '';
		// unreachable
		default:
			return '';
	}
}
